import { useState } from 'react';

export const useMultiFormView = () => {
	const [step, setStep] = useState(0);
	const [formData, setformData] = useState<any>({});
	const [enableButton, setEnableButton] = useState(true);
	const [showLoadingModal, setShowLoadingModal] = useState(false);
	const [showLongModal, setShowLongModal] = useState(false);
	return {
		step,
		setStep,
		formData,
		setformData,
		enableButton,
		setEnableButton,
		showLoadingModal,
		setShowLoadingModal,
		showLongModal,
		setShowLongModal,
	};
};
